import { formatOpportunityVerticalsDisplay } from 'domain/feature/hub/company/scouting/scoutingOpportunityDisplay'
import {
  getOpportunityCoverPathFromFiles,
  getOpportunitySupportFileDisplayName,
  getOpportunitySupportFiles,
  isOpportunitySupportFile,
  isValidOpportunityCoverPath,
} from 'domain/feature/hub/company/scouting/opportunityFiles'
import { isCurrentDateBiggerThanDeadline, removeTagsHTML } from 'sharedKernel/handlers'
import { DEFAULT_OPPORTUNITY_IMAGE } from './constants'
import type { IOpportunitySupportFile, IResolverOpportunity } from './contracts'

export const isOpportunityClosed = (
  opportunity: Pick<IResolverOpportunity, 'interestDeadline'>
): boolean => {
  const deadline = opportunity.interestDeadline?.trim()
  if (!deadline) return false
  return isCurrentDateBiggerThanDeadline(deadline)
}

export const formatVerticalDisplay = (
  opportunity: Pick<IResolverOpportunity, 'operationArea' | 'verticals' | 'otherVertical'>
): string => {
  const fullDisplay = formatOpportunityVerticalsDisplay(opportunity)
  if (!fullDisplay) return '-'

  const parts = fullDisplay.split(', ').filter(Boolean)
  if (parts.length <= 1) return fullDisplay
  return `${parts[0]}, +`
}

export const getDescriptionPreview = (description?: string): string => {
  const plainText = removeTagsHTML(description ?? '').trim()
  if (!plainText) return '-'
  return plainText
}

export const displayOrDash = (value?: string | number | null): string => {
  if (value === null || value === undefined || value === '') return '-'
  return String(value)
}

export { getOpportunitySupportFileDisplayName, isOpportunitySupportFile }

export const getResolverOpportunitySupportFiles = (
  fileRows: IOpportunitySupportFile[] | undefined,
  opportunity: IResolverOpportunity | null | undefined
): IOpportunitySupportFile[] =>
  getOpportunitySupportFiles(fileRows, opportunity)

export const getResolverOpportunityCoverImage = (
  opportunity: IResolverOpportunity | null | undefined,
  fileRows?: IOpportunitySupportFile[]
): string => {
  if (!opportunity) return DEFAULT_OPPORTUNITY_IMAGE

  const fromFileRows = getOpportunityCoverPathFromFiles(fileRows)
  if (fromFileRows) return fromFileRows

  const fromEmbeddedFiles = getOpportunityCoverPathFromFiles(opportunity.files)
  if (fromEmbeddedFiles) return fromEmbeddedFiles

  const candidates = [
    opportunity.coverImagePath,
    opportunity.style?.coverImagePath,
    opportunity.imagePath,
    opportunity.image,
  ]

  for (const candidate of candidates) {
    if (isValidOpportunityCoverPath(candidate)) return candidate
  }

  return DEFAULT_OPPORTUNITY_IMAGE
}

export const formatCompanySizeForDisplay = (companySize?: string): string => {
  const value = (companySize ?? '').trim()
  if (!value) return ''
  if (/funcionário/i.test(value)) return value
  return `${value} funcionários`
}

export const getStartupInitial = (name?: string): string => {
  const trimmed = (name ?? '').trim()
  if (!trimmed) return '?'
  return trimmed.charAt(0).toUpperCase()
}
